import { Loader2 } from 'lucide-react'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { SwapForm } from './forms/swap-form/SwapForm'
import { SwapViewProps } from '@/features/swap/logic/types'
import { InfoDropdown } from './InfoDropdown'
import { cn } from '@/ui/utils/style'

export enum Tab {
  Swap = 'Swap',
  Send = 'Send',
}

export function SwapPanel(props: SwapViewProps) {
  const { swap, withHeading, simplified, toTokens, featuredToAssets } = props

  return (
    <div className="w-full max-w-xl">
      {withHeading && (
        <Typography variant="h1" className="mb-7 pb-4 lg:text-4xl" gradient>
          Swap
        </Typography>
      )}
      <Wrapper simplified={simplified} withHeading={withHeading}>
        <SwapForm {...swap} lockedToToken={!!toTokens} featuredToAssets={featuredToAssets} />

        {swap.priceUpdating && (
          <div className="absolute right-8 bottom-2 flex items-center gap-1">
            <Loader2 className="h-3 w-3 animate-spin" />
            <p className="text-center text-white/70 text-xs italic">Getting quote...</p>
          </div>
        )}
      </Wrapper>

      {swap.swapError && <p className="mt-2 text-center text-red-300 text-sm">An error occurred while swapping</p>}

      {swap.swapMode === 'swap' && swap.priceData && 'result' in swap.priceData && (
        <InfoDropdown
          priceData={swap.priceData}
          fromToken={swap.fromToken}
          toToken={swap.toToken}
          priceUpdating={swap.priceUpdating}
        />
      )}
    </div>
  )
}

function Wrapper({
  simplified,
  withHeading,
  children,
}: { simplified?: boolean; withHeading?: boolean; children: React.ReactNode }) {
  if (simplified) {
    return children
  }

  return (
    <Panel.Wrapper className={cn('flex flex-col gap-4 p-4 pb-8 md:p-6 md:pb-8', !withHeading && 'p-2 pt-0')}>
      {children}
    </Panel.Wrapper>
  )
}
